<template>
  <div class="ctrl-login">
    <div class="wrap">
      <CtrlArticleRegisterArticle
        :categoryId="categoryId"
        :articleId="articleId"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlArticleRegisterArticle from "@/components/Ctrl/Article/RegisterArticle.vue";
export default {
  name: "ctrl-login",
  components: {
    CtrlArticleRegisterArticle,
  },
  props: {
    categoryId: String,
    articleId: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
